import React from 'react';
import { Icon } from 'component';

const MenuIcon = (props) => {
    const { name } = props;
    return <Icon name={name} className="mr-2" />;
};

// eslint-disable-next-line import/no-anonymous-default-export
export default [
    {
        icon: <MenuIcon name="crisis_alert" />,
        key: '1_gov',
        name: '政府平台',
        children: [
            { path: 'monitor', name: '監控查詢' },
            { path: 'reports', name: '報表下載' },
            { path: 'blacklist', name: '黑名單資料' }
        ]
    }
];
